import { useState } from 'react';

export const useImagensModule = ({ dados, setDados }) => {
    const [preview, setPreview] = useState([]);

    const actions = {
        onFileChange: (e) => {
            const files = Array.from(e.target.files);
            setPreview(files);

            // Sincroniza com o estado principal 'dados' para o submit do Form
            setDados((prev) => ({
                ...prev,
                images: files, // arquivos para upload (Multer no backend)
            }));
        },

        limparPreviews: () => setPreview([]),
    };

    return {
        state: {
            preview,
            produtoImagens: dados?.produtoImagems || [],
        },
        actions,
    };
};
